import { render, staticRenderFns } from "./ShipIowDashboardWidget.vue?vue&type=template&id=eb710e9a&scoped=true"
import script from "./ShipIowDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipIowDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipIowDashboardWidget.vue?vue&type=style&index=0&id=eb710e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb710e9a",
  null
  
)

export default component.exports